import React from "react";
import { useTranslation } from "react-i18next";
import { UxToast } from "@imaginelearning/mps-ux-component-library";
import HandRaised from "assets/hand-raised";
import "./no-lessons-modal.scss";

interface INoLessonsModalProps {
  showModal: boolean;
}

function NoLessonsModal({ showModal }: INoLessonsModalProps) {
  const { t } = useTranslation();

  return (
    <UxToast
      className="no-lessons-modal"
      show={true}
      dismissible={false}
      hideBorders={true}
      header={
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <HandRaised />
          <span style={{ paddingTop: "10px" }}>{t("No lessons available")}</span>
        </div>
      }
      body={
        <span className="body-text" style={{ display: "flex", justifyContent: "center" }}>
          {t("MyPath lessons are only available for ")} <br /> {t("students rostered in Grade K–12.")}
        </span>
      }
    />
  );
}

export default NoLessonsModal;
